import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { ANSWER } from 'store/Quiz/types'

const Question = (props) => {
  let language = props.language || {}
  const dispatch = useDispatch()

  useEffect(() => {
    if (props?.isContentQuiz && props?.question) {
      dispatch({ type: ANSWER, questions: props.question })
    }
  }, [props?.isContentQuiz, props.question, dispatch])

  return (
    <div className='col-md-12 px-0 quiz-space-bottom test'>
      <div className='row'>
        <div className='col-md-12'>
          <div
            className={`${
              !props.isSubmission ? 'position-absolute right-2' : ''
            }`}
          >
            {props.isSubmission && (
              <span
                className={`${
                  props.score == props.points ? 'text-success' : 'text-red'
                }`}
              >
                <b>{`${language.courses ? language.courses.points : null}: ${
                  props.score
                } / ${props.points}`}</b>
                {props.score == props.points && (
                  <FontAwesomeIcon className='ml-2' icon={faCheck} />
                )}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className='d-flex justify-content-between align-items-center'>
            <div
              dangerouslySetInnerHTML={{
                __html:
                  (typeof props.name === 'string' && props.name) || props.text,
              }}
              className='question-title'
            />
            {console.log(props.score, props.points, 'leart42')}
            {!props.isSubmission && (
              <span className='question-points'>
                <b>
                  {language.courses ? language.courses.points : null}:{' '}
                  {props.score !== undefined ? props.score : props.points}
                </b>
              </span>
            )}
          </div>
        </div>
      </div>
      <div className='quiz-row-wrapper mt-1 pt-3 border-top'>
        {props.children}
      </div>
    </div>
  )
}

export default Question
